module.exports = __webpack_public_path__ + "static/media/ic_invoice.004e351b.svg";